var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end align-items-center w-100 pt-2 pb-1"},[_c('div',[_vm._t("new-key-result-btn")],2),_c('div',{staticClass:"ml-3"},[_vm._t("toggle-key-results-btn")],2),_c('div',{staticClass:"ml-3"},[_vm._t("okrs-chart-btn")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }